import { useDisclosure } from '@chakra-ui/react';
import { useGenerateHtmlMinutes, } from '../../../../../../services/online/calendar/calendar';
import { DocumentKindEnum, } from '../../../../../document-details/type';
import { tKeys } from '../../../../../../translations/keys';
import { useTranslation } from 'react-i18next';
import { useEffect, useState, useRef, useCallback } from 'react';
import { useCompaniesContext } from '../../../../../../contexts/companies/index.web';
import useRouter from '../../../../../../hooks/router/useRouter.web';
import { useToast } from '../../../../../../components/content/use-toast/index.web';
import { useCreateDocument, useReadDocuments, useReadDocumentTypes, } from '../../../../../../services/online/repository/repository';
export const usePreviewMinutesLogic = (eventId) => {
    // Attributes
    const { t } = useTranslation();
    const { isOpen: isOpenPopover, onToggle: onTogglePopover } = useDisclosure();
    const { isOpen: isOpenConfirmDialog, onOpen: onOpenConfirmDialog, onClose: onCloseConfirmDialog, } = useDisclosure();
    const [isLoading, setIsLoading] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const { mutate: createDocument } = useCreateDocument();
    const [isMinuteAlreadyGenerated, setIsMinuteAlreadyGenerated] = useState(false);
    const { selectedCompanyId } = useCompaniesContext();
    const { push } = useRouter();
    const toast = useToast();
    const fileInputRef = useRef(null);
    const { mutate: generateHtmlMinutes, isLoading: isGeneratingHtmlMinutes } = useGenerateHtmlMinutes();
    const { data: documentTypes } = useReadDocumentTypes({
        'company-id': selectedCompanyId,
    }, {
        query: {
            enabled: !!selectedCompanyId,
        },
    });
    const minuteTypeId = documentTypes?.find(documentType => documentType.name === '_FT_BOARDMINUTE')?.id;
    const { data: minuteDocument, refetch: refetchDocuments, isLoading: isDocumentLoading, } = useReadDocuments({
        'company-id': selectedCompanyId,
        'document-types': [minuteTypeId],
        'event-id': eventId,
    }, {
        query: {
            enabled: !!selectedCompanyId && !!minuteTypeId && !!eventId,
        },
    });
    useEffect(() => {
        const minuteDocumentItem = minuteDocument?.[0]?.items.filter(item => item.typeName === '_FT_BOARDMINUTE');
        console.log('minuteDocumentItem', minuteDocumentItem);
        if (minuteDocumentItem?.length) {
            setIsMinuteAlreadyGenerated(true);
        }
    }, [minuteDocument]);
    function handleOnPressDocument() {
        if (!minuteDocument || !minuteDocument.length)
            return;
        const minuteDocumentItem = minuteDocument[0]?.items.filter(item => item.typeName === '_FT_BOARDMINUTE');
        if (!minuteDocumentItem || !minuteDocumentItem.length)
            return;
        const params = {
            documentKind: DocumentKindEnum?.DOCUMENT,
            documentId: minuteDocumentItem[0]?.id,
        };
        push('/company/document-details', {
            companyId: selectedCompanyId,
            ...params,
        });
    }
    // Functions
    const handleUploadDocument = async (acceptedFiles) => {
        const readFileAsBase64 = async (file) => {
            return await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const base64String = reader.result?.split(',')[1];
                    resolve(base64String);
                };
                reader.onerror = error => {
                    reject(error);
                };
                reader.readAsDataURL(file);
            });
        };
        const filesWithBase64 = await Promise.all(acceptedFiles.map(async (file, index) => {
            const base64 = await readFileAsBase64(file);
            return {
                path: acceptedFiles[index].path,
                lastModified: acceptedFiles[index].lastModified,
                lastModifiedDate: acceptedFiles[index].lastModifiedDate,
                name: acceptedFiles[index].name,
                size: acceptedFiles[index].size,
                type: acceptedFiles[index].type,
                webkitRelativePath: acceptedFiles[index].webkitRelativePath,
                base64,
            };
        }));
        console.log('filesWithBase64', filesWithBase64[0]);
        await createDocument({
            data: {
                companyId: selectedCompanyId,
                title: filesWithBase64[0].name,
                description: filesWithBase64[0].name,
                eventId,
                file: {
                    content: filesWithBase64[0].base64,
                    filename: filesWithBase64[0].name,
                    mimeType: filesWithBase64[0].type,
                },
                typeId: minuteTypeId,
            },
        }, {
            onSuccess: data => {
                refetchDocuments();
                toast({
                    title: 'Minutes published successfully',
                    status: 'success',
                    duration: 2000,
                });
                const params = {
                    documentKind: DocumentKindEnum?.DOCUMENT,
                    documentId: data.value,
                };
                push('/company/document-details', {
                    companyId: selectedCompanyId,
                    ...params,
                });
            },
            onError: () => {
                toast({
                    title: 'Error publishing minutes',
                    status: 'error',
                    duration: 2000,
                });
            },
        });
    };
    function handleEditMinutes() {
        setIsEditing(true);
        push('/company/minute-builder', {
            companyId: selectedCompanyId,
            eventId,
        });
        setIsEditing(false);
    }
    // New function to handle confirmation before regenerating minutes
    function confirmGenerateMinutes() {
        onOpenConfirmDialog();
    }
    // Function to proceed with generation after confirmation
    function handleConfirmRegenerate() {
        handleGenerateClick('fr-FR');
        onCloseConfirmDialog();
    }
    async function handleGenerateClick(culture) {
        setIsLoading(true);
        onTogglePopover(); // Close language selector popover
        generateHtmlMinutes({ eventId }, {
            onSuccess: () => {
                setIsLoading(false);
                handleEditMinutes();
            },
            onError: () => {
                setIsLoading(false);
                toast({
                    status: 'error',
                    title: t(tKeys.event.details.preview_minutes.title),
                });
            },
        });
    }
    async function handleFileChange(event) {
        const file = event.target.files?.[0];
        if (!file)
            return;
        setIsUploading(true);
        // try {
        //   const formData = new FormData();
        //   formData.append('file', file);
        //   formData.append('eventId', eventId);
        //   const { documentId } = await uploadMinutes(eventId, formData);
        //   await refetchDocuments();
        //   toast({
        //     status: 'success',
        //     title: t(tKeys.event.details.preview_minutes.upload_success),
        //   });
        //   // Optionally navigate to the document
        //   const params: DocumentDetailsRouteParams = {
        //     documentKind: DocumentKindEnum.MINUTES,
        //     eventId,
        //     documentId,
        //   };
        //   push('/company/document-details', {
        //     companyId: selectedCompanyId,
        //     ...params,
        //   });
        // } catch (err) {
        //   console.error(err);
        //   toast({
        //     status: 'error',
        //     title: t(tKeys.event.details.preview_minutes.upload_error),
        //   });
        // } finally {
        //   setIsUploading(false);
        //   if (fileInputRef.current) {
        //     fileInputRef.current.value = '';
        //   }
        // }
    }
    // Add confirmation dialog state
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    // Open and close handlers
    const openConfirmDialog = useCallback(() => {
        setIsConfirmDialogOpen(true);
    }, []);
    const closeConfirmDialog = useCallback(() => {
        setIsConfirmDialogOpen(false);
    }, []);
    // When confirmation is approved
    const handleRegenerateConfirmed = useCallback(async () => {
        closeConfirmDialog();
        handleGenerateClick('fr-FR');
        // await confirmGenerateMinutes(); // Call the existing regeneration function
    }, [confirmGenerateMinutes]);
    // Return
    return {
        isOpenPopover,
        onTogglePopover,
        isOpenConfirmDialog,
        onOpenConfirmDialog,
        onCloseConfirmDialog,
        isLoading,
        isUploading,
        isEditing,
        handleGenerateClick,
        handleOnPressDocument,
        handleUploadDocument,
        handleFileChange,
        handleEditMinutes,
        confirmGenerateMinutes,
        handleConfirmRegenerate,
        fileInputRef,
        isDocumentLoading,
        isMinuteAlreadyGenerated,
        isGeneratingHtmlMinutes,
        isConfirmDialogOpen,
        openConfirmDialog,
        closeConfirmDialog,
        handleRegenerateConfirmed,
    };
};
